export default function getSearchParams(request: Request) {
  return new URL(request.url).searchParams;
}
